/* eslint-disable @typescript-eslint/explicit-function-return-type */
import styled, { css } from "styled-components";

export type Size = "S" | "M" | "L" | "XL";
export type FlexJustify = "flex-start" | "flex-end" | "center" | "space-around" | "space-between" | "space-evenly";
export type FlexAlign = "flex-start" | "flex-end" | "center" | "stretch" | "baseline" | "self-end";

interface FlexProps {
	gap?: number | Size;
	justify?: FlexJustify;
	align?: FlexAlign;
	reverse?: boolean;
	wrap?: boolean;
}
interface GridProps {
	gap: number | Size;
	cellWidth: number | string;
	justify?: FlexJustify;
	align?: FlexAlign;
}

export const sizes: Record<Size, string> = {
	S: "10px",
	M: "20px",
	L: "30px",
	XL: "40px",
};

export const stack = (
	gap: number | Size,
	justify: FlexJustify = "flex-start",
	align: FlexAlign = "flex-start",
	reverse?: "reverse",
	noMarginBotoom = false
) => css`
	display: flex;
	flex-direction: ${reverse ? "column-reverse" : "column"};
	justify-content: ${justify};
	align-items: ${align};

	> *:not(:last-child) {
		${`${reverse ? "margin-top:" : "margin-bottom:"}${typeof gap === "number" ? `${gap}px` : sizes[gap]}`};
		${`${noMarginBotoom ? "margin-bottom:0px" : undefined}`};
	}
`;

export const Stack = styled.div<FlexProps>`
	${({ gap = 0, justify, align, reverse }) => stack(gap, justify, align, reverse ? "reverse" : undefined)};
`;

export const row = (
	gap: number | Size,
	justify: FlexJustify = "flex-start",
	align: FlexAlign = "flex-start",
	reverse?: "reverse",
	wrap?: boolean
) => css`
	display: flex;
	flex-direction: ${reverse ? "row-reverse" : "row"};
	justify-content: ${justify};
	align-items: ${align};
	flex-wrap: ${wrap ? "wrap" : "no-wrap"};

	> *:not(:last-child) {
		${`${reverse ? "margin-left:" : "margin-right:"}${typeof gap === "number" ? `${gap}px` : sizes[gap]}`};
	}
`;
export const Row = styled.div.withConfig({
	shouldForwardProp: (prop) => !["gap", "justify", "align", "reverse", "wrap"].includes(prop),
})<FlexProps>`
	${({ gap = 0, justify, align, reverse, wrap }) => row(gap, justify, align, reverse ? "reverse" : undefined, wrap)};
`;

export const Bloc = styled.div`
	position: relative;
	font-family: Sora;
	margin-top: 12px;
	${({ theme }) => theme.colors.primary};
	font-size: 13px;
	font-weight: 100;
`;

export const grid = (
	gap: number | Size,
	cellWidth: number | string,
	justify: FlexJustify = "flex-start",
	align: FlexAlign = "flex-start"
) => css`
	display: grid;
	grid-template-columns: repeat(auto-fill, ${typeof cellWidth === "number" ? `${cellWidth}px` : cellWidth});
	gap: ${typeof gap === "number" ? `${gap}px` : sizes[gap]};
	justify-content: ${justify};
	align-items: ${align};
`;
export const Grid = styled.div<GridProps>`
	${({ gap, cellWidth, justify, align }) => grid(gap, cellWidth, justify, align)};
`;

export const Spacer = styled.div.withConfig({
	shouldForwardProp: (prop) => prop !== "space",
})<{ space?: number }>`
	flex: ${(props) => props.space ?? 1};
	margin-bottom: 0 !important;
	margin-left: 0 !important;
	margin-right: 0 !important;
	margin-top: 0 !important;
`;
